/**
 * @fileoverview Dev-Only Route Group
 *
 * Purpose: Protects routes that should ONLY be accessible in development
 * Security: Multi-layer protection (env check + hostname verification)
 *
 * Protected Routes:
 * - /component-library - UI component showcase
 */

import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/_dev")({
  beforeLoad: async ({ location }) => {
    // Layer 1: Check if we're in development mode
    const isDevelopment = import.meta.env.DEV;

    // Layer 2: Check if hostname is localhost (additional security)
    const isLocalhost =
      window.location.hostname === "localhost" ||
      window.location.hostname === "127.0.0.1" ||
      window.location.hostname === "[::1]";

    // Layer 3: Optional - check for dev mode explicitly
    const isDevMode = import.meta.env.MODE === "development";

    // Strict check: ALL conditions must be true
    if (!isDevelopment || !isLocalhost || !isDevMode) {
      console.warn(
        "Attempted access to dev-only route in production. Redirecting...",
      );

      throw redirect({
        to: "/",
        replace: true,
      });
    }

    // Additional logging in dev to confirm access
    if (isDevelopment) {
      // eslint-disable-next-line no-console -- dev-only route access confirmation, gated by DEV
      console.log("✅ Dev-only route access granted:", location.pathname);
    }
  },
});
